import { useAuthContext } from "@/components/auth"
import { MenuItem, menuItems } from "@/components/layout/menuItems"
import { RootState } from "@/redux/store"
import { Button, Drawer, Layout, Menu, Modal, Space } from "antd"
import { split, trimStart } from "lodash"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"

const renderModalFooter = (onOk: () => void, onCancel: () => void) => {
  return (
    <>
      <Space>
        <Button
          type="primary"
          danger
          onClick={() => {
            onOk()
          }}
        >
          Đăng xuất
        </Button>
        <Button
          key="cancel"
          onClick={() => {
            onCancel()
          }}
        >
          Hủy
        </Button>
      </Space>
    </>
  )
}

const hasPermission = (item: MenuItem, userPermissions: string[]): boolean => {
  if (!item.permissionKey) return true // Nếu không có key permission thì luôn hiển thị
  return item.permissionKey.some(permission => userPermissions.includes(permission))
}

// Hàm lọc menu
export const filterMenuItems = (items: MenuItem[], userPermissions: string[]): MenuItem[] => {
  return items
    .filter(item => hasPermission(item, userPermissions)) // Lọc menu cha theo quyền
    .map(item => ({
      ...item,
      children: item.children ? filterMenuItems(item.children as MenuItem[], userPermissions) : undefined, // Lọc đệ quy cho menu con
    }))
    .filter(item => !(item.children && item.children.length === 0)) // Loại bỏ menu cha không có con hợp lệ
}

// Hàm loại bỏ permissionKey khỏi menu items để tránh warning
const removePermissionKey = (items: MenuItem[]): any[] => {
  return items.map(item => {
    const { permissionKey, ...rest } = item
    return {
      ...rest,
      children: item.children ? removePermissionKey(item.children as MenuItem[]) : undefined,
    }
  })
}

export const Header = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const auth = useAuthContext()
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false)
  const [isDrawerVisible, setIsDrawerVisible] = useState<boolean>(false)
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 768)
  const parts = split(trimStart(location.pathname, "/"), "/")
  const profile: any = useSelector<RootState>((state: RootState) => state.profile)
  const [isUserMenuOpen, setUserMenuOpen] = useState(false)

  const handleUserMenuClick = () => {
    setUserMenuOpen(prev => !prev)
  }

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768)
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  // const userPermissions = profile.user.permissions || [] // Lấy quyền từ profile
  const userPermissions = auth.permissions || [] // Lấy quyền từ auth
  const accessibleMenuItems = filterMenuItems(menuItems as MenuItem[], userPermissions)
  const cleanMenuItems = removePermissionKey(accessibleMenuItems)
  return (
    <Layout.Header
      className="layout"
      style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
    >
      <Modal
        title="Bạn chắc chắn muốn đăng xuất?"
        open={isOpenModal}
        width={600}
        onCancel={() => setIsOpenModal(false)}
        footer={renderModalFooter(
          () => auth.logout(),
          () => setIsOpenModal(false),
        )}
      />
      <a className="logo" onClick={() => navigate("/")} href="/">
        <img src="/images/logo.png" alt="Logo" />
      </a>
      <div
        style={{
          width: isMobile ? "" : "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {isMobile ? (
          <>
            <Button
              type="default"
              onClick={() => setIsDrawerVisible(true)}
              style={{
                fontSize: "1.5rem",
                padding: "0 0.5rem",
                border: "none",
                background: "none",
                color: "black",
                cursor: "pointer",
              }}
            >
              ☰
            </Button>
            <Drawer title="Menu" placement="right" onClose={() => setIsDrawerVisible(false)} open={isDrawerVisible}>
              <Menu
                mode={isMobile ? "inline" : "horizontal"}
                // mode="vertical"
                items={cleanMenuItems}
                onClick={info => {
                  navigate(info.key)
                  setIsDrawerVisible(false)
                }}
                defaultSelectedKeys={[parts[0] ? parts[0] : "/"]}
              />
              <Button
                type="primary"
                danger
                onClick={() => setIsOpenModal(true)}
                style={{ width: "100%", marginTop: "1rem" }}
              >
                Đăng xuất
              </Button>
            </Drawer>
          </>
        ) : (
          <Menu
            mode="horizontal"
            items={cleanMenuItems}
            onClick={info => navigate(info.key)}
            defaultSelectedKeys={[parts[0] ? parts[0] : "/"]}
            onSelect={info => navigate(info.key)}
            style={{
              flex: "auto",
              display: "flex",
              justifyContent: "center",
              background: "transparent",
              borderBottom: "none",
            }}
          />
        )}
        {/* <Menu
          mode="horizontal"
          items={menuItems}
          onClick={info => {
            navigate(info.key)
          }}
          defaultSelectedKeys={[parts[0] ? parts[0] : "/"]}
          onSelect={info => {
            navigate(info.key)
          }}
          style={{ minWidth: 0, flex: "auto" }}
        /> */}
        {/* <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", width: "auto" }}>
          <p>Hi, {profile.user.user_fullname}</p>
          <Button type="primary" danger onClick={() => setIsOpenModal(true)}>
            Đăng xuất
          </Button>
        </div> */}

        {!isMobile && (
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", position: "relative" }}>
            <img
              src="/images/avatar-default.svg"
              alt="User Avatar"
              onClick={handleUserMenuClick}
              style={{
                cursor: "pointer",
                width: "2rem",
                height: "2rem",
                borderRadius: "50%",
                border: "2px solid #818cf8 ",
              }}
            />

            {isUserMenuOpen && (
              <Menu
                mode="vertical"
                className="menu-dropdown z-50 absolute right-1 top-full shadow-lg drop-shadow-md px-2 py-1 "
                onClick={handleUserMenuClick}
                style={{
                  zIndex: 50,
                  position: "absolute",
                  top: "100%",
                  right: "0",
                  boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                }}
              >
                <Menu.Item key="logout" onClick={() => setIsOpenModal(true)}>
                  Đăng xuất
                </Menu.Item>
              </Menu>
            )}
          </div>
        )}
      </div>

      {/* <Dropdown overlay={rightMenu}>
        <a onClick={e => e.preventDefault()}>Hi, {profile.data.username}</a>
      </Dropdown> */}
    </Layout.Header>
  )
}
